import { render, staticRenderFns } from "./ProjectNotes.vue?vue&type=template&id=c9269ba4&"
import script from "./ProjectNotes.vue?vue&type=script&lang=js&"
export * from "./ProjectNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports